import styled from 'styled-components';

import {Texto} from './Utils';

const DescricaoContainer =  styled.div`
    box-shadow: 2px 2px 2px rgb(0 0 0 / 10%), -1px 0 2px rgb(0 0 0 / 5%);
    padding: 10px 30px;
    background: white;
    .titulo{
        font-size: 1.3rem;
    }
`;

const DescricaoPagina = ({titulo, className}) => {
	return(
		<DescricaoContainer className={className}>
            <Texto className="m-0 titulo" tamanho="1.3rem" weight="600">{titulo}</Texto>
        </DescricaoContainer>
	)
}

export default DescricaoPagina
